<template>
  <v-card class="mx-auto">
    <v-btn
      dark
      absolute
      fixed
      bottom
      large
      right
      fab
      color="primary"
      @click="dialog = !dialog"
      class="mr-4 mb-16 fabNav"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Bailleurs
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Bailleur</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="formBaillleur" v-model="valid" lazy-validation>
            <v-text-field
              v-model="abbr_bailleur"
              label="Abbréviation"
              prepend-icon="label"
              :rules="nameRules"
              required
            ></v-text-field>

            <v-text-field
              v-model="ll_bailleur"
              label="Nom"
              prepend-icon="label"
              :rules="nameRules"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded class="primary" text @click="closeDialog"
            >Annuler</v-btn
          >
          <v-btn rounded class="primary" text @click="updateCreateBailleur"
            >Sauvegarder</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-text class="text-left">
      <template>
        <v-window height="auto" v-model="onboarding">
          <v-window-item v-for="(item, index) in bailleurs" :key="index">
            <v-card class="mb-3 grey lighten-1 white--text">
              <v-system-bar dark color="blue darken-1" height="50">
                <v-btn
                  outlined
                  small
                  fab
                  dark
                  class="transparent"
                  @click="prev"
                >
                  <v-icon>mdi-chevron-left-circle-outline</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                {{ item.abbr_bailleur }}
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  small
                  fab
                  dark
                  class="transparent"
                  @click="next"
                >
                  <v-icon>mdi-chevron-right-circle-outline</v-icon>
                </v-btn>
              </v-system-bar>
              <v-card-actions>
                <v-btn outlined rounded dark @click="addProjet(item)">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                  projet
                </v-btn>
                <v-spacer></v-spacer>

                <v-btn
                  outlined
                  x-small
                  fab
                  dark
                  class="warning"
                  @click="openDialog(item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  outlined
                  x-small
                  fab
                  dark
                  class="danger"
                  @click="deleteBailleur(item)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>

                <!--  <v-btn icon @click="detailsBailleur(item)">
              <v-icon>chevron_right</v-icon>
            </v-btn> -->
              </v-card-actions>
              <v-card-title> {{ item.abbr_bailleur }}</v-card-title>
              <v-card-subtitle> {{ item.ll_bailleur }}</v-card-subtitle>
              <v-card-text>
                <Projets :bailleur="item" />
              </v-card-text>
            </v-card>
          </v-window-item>
        </v-window>
      </template>

      <template>
        <v-row justify="center">
          <v-dialog v-model="dialogAddProjet" max-width="400">
            <v-card>
              <v-card-title class="headline">{{
                bailleurSelected.abbr_bailleur
              }}</v-card-title>

              <v-card-text class="text-left">
                <v-form ref="formNewProjet">
                  <v-text-field
                    v-model="ll_programme"
                    label="Projet"
                    prepend-icon="post_add"
                  ></v-text-field>

                  <v-textarea
                    v-model="objectifs"
                    prepend-icon="short_text"
                    label="Objectifs"
                  ></v-textarea>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  rounded
                  class="primary"
                  text
                  @click="closeDialogAddProjet"
                >
                  Annuler
                </v-btn>

                <v-btn
                  rounded
                  class="primary"
                  text
                  @click="addProjetToBailleur(id_bailleur)"
                >
                  Ajouter Projet
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-card-text>
    <v-card-actions>
      <Navigation :elements="AdminNavigation" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
//import VueJsonPretty from "vue-json-pretty";
//import OrganizationChart from "vue-organization-chart";
//import "vue-organization-chart/dist/orgchart.css";
export default {
  components: {
    //OrganizationChart,
    //VueJsonPretty,
    Navigation: require("@/components/Navigation.vue").default,
    Projets: require("@/components/organisation/projets").default,
  },
  data: () => ({
    onboarding: 0,
    valid: true,
    nameRules: [
      (v) => !!v || "requis",
      (v) => (v && v.length >= 2) || "Au moins deux caractères",
    ],
    abbr_bailleur: "",
    ll_bailleur: "",
    id_bailleur: null,
    dialog: false,
    dialogDeleteBailleur: false,
    dialogAddProjet: false,
    dialogLoading: false,
    bailleurSelected: {},
    activites: [],
    newBailleurs: {},
    ll_programme: "",
    objectifs: "",
    headers_bailleurs: [
      {
        text: "Abréviation",
        align: "start",
        value: "abbr_bailleur",
      },
      {
        text: "Nom",
        value: "ll_bailleur",
      },

      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  created() {
    this.getBailleurs();
    this.getProjets();
    this.GetActivites();
    this.GetThemes();

  },
  methods: {
   
    next() {
      this.onboarding =
        this.onboarding + 1 === this.bailleurs.length ? 0 : this.onboarding + 1;
    },
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0
          ? this.bailleurs.length - 1
          : this.onboarding - 1;
    },
    openDialog(bailleur) {
      this.dialog = true;
      this.abbr_bailleur = bailleur.abbr_bailleur;
      this.ll_bailleur = bailleur.ll_bailleur;
      this.id_bailleur = bailleur.id;
    },
    updateCreateBailleur() {
      let self = this;
      if (this.$refs.formBaillleur.validate()) {
        //update bailleur
        if (this.id_bailleur !== null) {
          this.dialogLoading = true;
          let bailleurRef = this.$firebase
            .firestore()
            .collection("bailleurs")
            .doc(this.id_bailleur);
          return bailleurRef
            .update({
              abbr_bailleur: self.abbr_bailleur,
              ll_bailleur: self.ll_bailleur,
            })
            .then(function () {
              // console.log("Bailleur successfully updated!");
              self.udpdateProjetsDeBailleur(
                self.id_bailleur,
                self.abbr_bailleur,
                self.ll_bailleur
              );
              self.dialogLoading = false;
              self.id_bailleur = null;

              self.closeDialog();
            })
            .catch(function (error) {
              // The document probably doesn't exist.
              console.error("Error updating document: ", error);
              self.closeDialog();
            });
        } else {
          //create Bailleur
          this.dialogLoading = true;
          // Add a new document with a generated id.
          this.$firebase
            .firestore()
            .collection("bailleurs")
            .add({
              abbr_bailleur: self.abbr_bailleur,
              ll_bailleur: self.ll_bailleur,
            })
            .then(function (docRef) {
              //console.log("New Document written with ID: ", docRef.id);
              self.dialogLoading = false;
              self.id_bailleur = null;
              self.closeDialog();
            })
            .catch(function (error) {
              console.error("Error adding document: ", error);
              self.closeDialog();
            });
        }
        self.closeDialog();
      }
    },
    closeDialog() {
      this.dialog = false;
      this.dialogDeleteBailleur = false;
      this.$refs.formBaillleur.reset();
    },

    udpdateProjetsDeBailleur(idBailleur, abbr_bailleur, ll_bailleur) {
      console.log(abbr_bailleur);
      //getAllprojets fist
      let self = this;
      this.$firebase
        .firestore()
        .collection("projets")
        .where("id_bailleur", "==", idBailleur)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, " => ", doc.data());
            ///

            const projet = self.$firebase
              .firestore()
              .collection("projets")
              .doc(doc.id);
            // Set the 'capital' field of the city
            projet.update({
              abbr_bailleur: abbr_bailleur,
              ll_bailleur: ll_bailleur,
            });

            ///
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },

    detailsBailleur(bailleur) {
      ////console.log(bailleur.id);
      this.$router.push({
        name: "organisation-projetsDuBailleur",
        params: { bailleur },
      });
    },

    addProjet(bailleur) {
      this.dialogAddProjet = true;
      this.bailleurSelected = bailleur;

      //console.log(bailleur);
    },
    addProjetToBailleur() {
      this.dialogLoading = true;
      let self = this;
      let newProjet = {};
      newProjet.ll_programme = this.ll_programme;
      newProjet.objectifs = this.objectifs;
      newProjet.id_bailleur = this.bailleurSelected.id;
      newProjet.abbr_bailleur = this.bailleurSelected.abbr_bailleur;
      newProjet.bailleurs_id_bailleur = this.bailleurSelected.id;
      newProjet.ll_bailleur = this.bailleurSelected.ll_bailleur;
      newProjet.abbr_bailleur = this.bailleurSelected.abbr_bailleur;
      console.log(newProjet);

      // Add a new document with a generated id.
      this.$firebase
        .firestore()
        .collection("projets")
        .add(newProjet)
        .then(function (docRef) {
          console.log("Document written with ID: ", docRef.id);
          self.$refs.formNewProjet.reset();
          self.dialogAddProjet = false;
          self.dialogLoading = false;
          /*    self.$router.push({
            name: "organisation-projetsDuBailleur",
            params: { bailleur: self.bailleurSelected },
          }); */
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });
    },
    closeDialogAddProjet() {
      this.dialogAddProjet = false;
      this.$refs.formNewProjet.reset();
    },
    deleteBailleur(bailleur) {
      let self = this;
      //delete bailleur in collection bailleurs
      const index = this.bailleurs.indexOf(bailleur);
      this.$confirm(
        "Voulez vous Effacer ce bailleur?, Cela entrainera l'effacement des projet liés "
      ).then((ok) => {
        if (ok) {
          //delete bailleur in collection bailleurs
          this.bailleurs.splice(index, 1);
          this.$firebase
            .firestore()
            .collection("bailleurs")
            .doc(bailleur.id)
            .delete()
            .then(function () {
              console.log("Bailleur successfully deleted!");
              //const index = self.bailleurs.indexOf(id_bailleur)
            })
            .catch(function (error) {
              console.error("Error removing document: ", error);
            });

          //delete projects which has bailleur in collection projets
          //first get projects of Bailleur
          let projectsOfBailleur = [];
          this.$firebase
            .firestore()
            .collection("projets")
            .where("id_bailleur", "==", bailleur.id.toString())
            .get()
            .then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                // doc.data() is never undefined for query doc snapshots
                // console.log(doc.id, " => ", doc.data());
                projectsOfBailleur.push({
                  ...doc.data(),
                  id: doc.id,
                });
                projectsOfBailleur.forEach((projet, index) => {
                  //console.log(`Current index: ${index}`);
                  //console.log(projet.id);
                  self.deleteProject(projet.id);
                });
              });
            })
            .catch(function (error) {
              console.log("Error getting documents: ", error);
            });
        }
      });
    },
    deleteProject(idProjet) {
      this.$firebase
        .firestore()
        .collection("projets")
        .doc(idProjet)
        .delete()
        .then(function () {
          //console.log("Document successfully deleted!");
          //const index = self.bailleurs.indexOf(id_bailleur)
        })
        .catch(function (error) {
          console.error("Error removing document: ", error);
        });
    },

    ...mapActions({
      getBailleurs: "Bailleurs/getListeBailleurs",
      getProjets: "Projets/getListeProjets",
      GetActivites: "Activites/GetAll",
      GetThemes: "Themes/GetAll",
    }),
  },
  computed: {
    ...mapState({
      bailleurs: (state) => state.Bailleurs.bailleurs,
      projets: (state) => state.Projets.projets,
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
    }),
  },
};
</script>
<style></style>
